import { render, staticRenderFns } from "./specialDiscounts.vue?vue&type=template&id=c0ea3e6c&scoped=true"
import script from "./specialDiscounts.vue?vue&type=script&lang=js"
export * from "./specialDiscounts.vue?vue&type=script&lang=js"
import style0 from "./specialDiscounts.vue?vue&type=style&index=0&id=c0ea3e6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ea3e6c",
  null
  
)

export default component.exports